<template>
  <div class="animated fadeIn">
    <b-card no-header>
      <b-form>
        <b-form-group
          label="Pesos"
          label-for="pesos"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="pesos"
            v-model.trim="$v.pesos.$model" 
            :state="pesosValidos"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="pesosFeedback">
            {{ pesosInvalidosMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </b-form>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="close">Cancelar</b-button>
      </div>
    </b-card>
    
    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>


<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

import { required, decimal } from 'vuelidate/lib/validators';

export default {
  name: 'ABM',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    cajaRegistroId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      noValidar: true,
      pesosValidos: null,
      pesosInvalidosMsj: '',
      
      pesos: 0,

      labelCols: 2
    }
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'pesos' || validarTodos) {
        if (this.$v.pesos.$error) {
          this.pesosValidos = false;
          if (!this.$v.pesos.required) {
            this.pesosInvalidosMsj = 'Debe ingresar el importe del ajuste';
          } else if (!this.$v.pesos.decimal) {
            this.pesosInvalidosMsj = 'El importe debe ser un valor numérico';
          }
          // } else if (!this.$v.pesos.minValue) {
          //   this.pesosInvalidosMsj = 'Ingrese el importe a transferir';
          // } 
        } else {
          this.pesosValidos = null;
          this.pesosInvalidosMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      if (this.pesos == 0) {
        this.pesosValidos = false;
        this.pesosInvalidosMsj = 'Debe ingresar el importe del ajuste';
        save = false;
      }

      this.$v.$touch()

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let ajuste = {
            cajaRegistroId: this.cajaRegistroId,
            documentoTipoId: 101,
            importe: this.pesos,
          }

          this.showSpinner();
          this.$store.dispatch('cajasregistros/ajusteCaja', ajuste)
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.close.bind(this, true), this.close.bind(this, true), 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    close(ajusteRegistrado) {
      this.$emit('close', ajusteRegistrado);
    },
  },
  validations: {
    pesos: {
      required,
      decimal,
      // minValue: minValue(1)
    },
  },  
}
</script>

<style>
</style>
